// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__14yjz","iconButton":"styles_iconButton__VgLfe"};